import { Reducer } from 'redux';
import {
  DocumentsAction,
  DocumentsActionTypes,
  DocumentsStore,
} from './documentsTypes';

const initialState: DocumentsStore = {
  uploadedDocuments: [],
  isUploading: false,
  isLoadingDocuments: false,
};

const documentsReducer: Reducer<DocumentsStore, DocumentsAction> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case DocumentsActionTypes.SET_UPLOADED_DOCUMENTS:
      return {
        ...state,
        uploadedDocuments: action.payload,
      };
    case DocumentsActionTypes.ADD_UPLOADED_DOCUMENTS:
      return {
        ...state,
        uploadedDocuments: [
          ...state.uploadedDocuments,
          ...action.payload.filter(
            (document) =>
              !state.uploadedDocuments.some(
                (existing) => existing.documentId === document.documentId,
              ),
          ),
        ],
      };
    case DocumentsActionTypes.UPDATE_UPLOADED_DOCUMENT_STATUS:
      return {
        ...state,
        uploadedDocuments: state.uploadedDocuments.map((document) =>
          document.documentId === action.payload.documentId
            ? { ...document, status: action.payload.status }
            : document,
        ),
      };
    case DocumentsActionTypes.REMOVE_UPLOADED_DOCUMENT:
      return {
        ...state,
        uploadedDocuments: state.uploadedDocuments.filter(
          (document) => document.documentId !== action.payload,
        ),
      };
    case DocumentsActionTypes.SET_DOCUMENTS_UPLOADING:
      return {
        ...state,
        isUploading: action.payload,
      };
    case DocumentsActionTypes.SET_DOCUMENTS_LOADING:
      return {
        ...state,
        isLoadingDocuments: action.payload,
      };
    default:
      return state;
  }
};

export default documentsReducer;
